import React from 'react';

import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';

import SwitcherComponent from '../../components/Headers/SwitcherComponent';

import { TabType } from '../../types';
import useTableContext, { PageType } from './useTableContext';

const PREFIX = 'DataGridToolBar';

const classes = {
  root: `${PREFIX}-root`,
  portalContainer: `${PREFIX}-portalContainer`
};

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: { justifyContent: 'space-between', display: 'flex' },

  [`& .${classes.portalContainer}`]: {
    display: 'flex',
    '&:only-child': {
      width: '100%'
    }
  }
}));

type Props = {
  tabulatedItems: TabType[];
  tabbedElement: TabType;
  setTabbedElement: React.Dispatch<TabType>;
  page;
};

const DataGridToolBar = ({
  tabulatedItems,
  tabbedElement,
  setTabbedElement,
  page
}: Props) => {
  const { contentNodeForButtons, context } = useTableContext();

  return (
    <Root className={classes.root}>
      {context?.type === PageType.LIST && tabulatedItems.length > 1 ? (
        <Box mr={2} sx={{ whiteSpace: 'nowrap' }}>
          <SwitcherComponent
            tabbedElement={tabbedElement}
            tabulatedItems={tabulatedItems}
            setTabbedElement={setTabbedElement}
            page={page}
          />
        </Box>
      ) : (
        <></>
      )}
      <div
        className={classes.portalContainer}
        data-testid="portal"
        ref={contentNodeForButtons}
      />
    </Root>
  );
};

export default DataGridToolBar;
